var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#466AEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 23.3707C18 18.759 21.6824 15 26.25 15C30.8176 15 34.5 18.759 34.5 23.3707C34.5 26.4367 32.8687 28.7424 30.5164 30.1507C30.419 30.209 30.3703 30.2913 30.3587 30.3612L30.0793 32.0377C29.9386 32.8815 29.2085 33.5 28.3531 33.5H24.0473C23.1919 33.5 22.4618 32.8815 22.3211 32.0377L22.0417 30.3612C22.0301 30.2916 21.9814 30.2087 21.8828 30.1494C19.5264 28.7312 18 26.4188 18 23.3707Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 34.75C23.25 35.8546 24.1454 36.75 25.25 36.75H27.25C28.3546 36.75 29.25 35.8546 29.25 34.75V32.75H27.25V34.75H25.25V32.75H23.25V34.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/Innovation.6db155304ed8f28f43d8ac3178a2032e.svg";
export { ForwardRef as ReactComponent };